module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA3NjkuM2wtMjQzLjkgMTI3LjJhMzIgMzIgMCAwIDEtNDYuMy0zMy43bDQ1LjYtMjcxLjMtMTk2LjQtMTkyLjZhMzIgMzIgMCAwIDEgMTcuNy01NC41bDI3Mi4xLTQwLjQgMTIyLjYtMjQ2LjNhMzIgMzIgMCAwIDEgNTcuMyAwbDEyMi42IDI0Ni4zIDI3Mi4xIDQwLjRhMzIgMzIgMCAwIDEgMTcuNyA1NC41bC0xOTYuNCAxOTIuNyA0NS42IDI3MS4zYTMyIDMyIDAgMCAxLTQ2LjMgMzMuN0w1MTIgNzY5LjJ6IiBmaWxsPSIjMCIgcC1pZD0iMzc1NSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Star-filled.svg
// module id = JaOK
// module chunks = 74